import {
  Card,
  CardContent,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Grid,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { entityPageTranslationRef } from '../../../translation/entity-page/entity-page';

type EnvStatusCardProps = {
  label: string;
  configured: boolean;
  onAddTemplate: () => void;
};

export const EnvStatusCard = ({ label, configured, onAddTemplate }: EnvStatusCardProps) => {
  const color = configured ? '#2e7d32' : '#9e9e9e';
  const bgColor = configured ? '#e8f5e9' : '#f5f5f5';
  const { t } = useTranslationRef(entityPageTranslationRef);

  return (
    <Card
      elevation={1}
      style={{
        borderLeft: `6px solid ${color}`,
        backgroundColor: bgColor,
      }}
    >
      <CardContent>
        <Grid container direction='row' alignItems="flex-start" justifyContent="space-between">
          <Grid item>
            <Box display="flex" alignItems="center" gridGap={8}>
              {configured ? (
                <CheckCircleIcon style={{ color }} />
              ) : (
                <RemoveCircleOutlineIcon style={{ color }} />
              )}

              <Typography variant="h6">
                {label}
              </Typography>
            </Box>

            <Typography
              variant="body2"
              style={{ marginTop: 8, color: '#616161' }}
            >
              {configured ? t('cicdContent.configEditorCdEnvironmentConfigured') : t('cicdContent.configEditorCdEnvironmentNotConfigured')}
            </Typography>
          </Grid>

          <Grid item>
            {!configured && <Tooltip title={t('cicdContent.configEditorAddCdTemplateEnvironment')}>
              <IconButton
                size="small"
                onClick={onAddTemplate}
                style={{ top: 8, right: 8 }}
              >
                <AddCircleOutlineIcon color="secondary" />
              </IconButton>
            </Tooltip>}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
